import cn from "classnames";

import { ModalSheet } from "shared/ui/components/ModalSheet";
import { Modal } from "shared/ui/components/Modal";
import { Typography } from "shared/ui/components/Typography";
import { Button } from "shared/ui/components/Button";

import CheckIcon from "assets/icons/check.svg?react";

import { ModalOfferType } from "./ModalOffer.types";

import styles from "./ModalOffer.module.scss";

const ModalOffer = ({
  modalIsOpen,
  modalOpenType,
  modals,
  onCloseClick,
}: ModalOfferType) => {
  if (!modals || !modals[modalOpenType]) {
    return null;
  }

  const {
    badge,
    title,
    titleHeading,
    description,
    list,
    imageUrl,
    imageAltText,
    buttonText,
    buttonLink
  } = modals[modalOpenType];

  return (
    <>
      <ModalSheet
        open={modalIsOpen}
        centered={false}
        className={cn(styles.modal, styles.mobileModal)}
        portalClassName={styles.portalMobile}
        onClose={onCloseClick}
      >
        <div className={styles.formWrapper}>
          {badge &&
            <Typography
              variant="bodyS"
              className={styles.badge}
              component="span"
            >
              {badge}
            </Typography>
          }
          <Typography
            variant="h3"
            weight="semiBold"
            className={styles.title}
          >
            {title} {titleHeading && <span className={styles.titleHeading}>{titleHeading}</span>}
          </Typography>
          <Typography
            variant="bodyM"
            className={styles.description}
          >
            {description}
          </Typography>
          {list
            && <ul className={styles.list}>
              {list.map((item, index) => (
                <Typography
                  key={index}
                  className={styles.listItem}
                  variant="bodyM"
                  component="li"
                >
                  <CheckIcon className={styles.listIcon} />
                  {item}
                </Typography>
              ))}
            </ul>
          }
          <div className={styles.actions}>
            {buttonText.length > 0 && (
              <Button
                variant="back"
                className={styles.action}
                onClick={onCloseClick}
                component="a"
                href={buttonLink}
              >
                {buttonText}
              </Button>
            )}
          </div>
        </div>
        {imageUrl && (
          <div className={styles.imageWrapper}>
            <img src={imageUrl} alt={imageAltText} className={styles.image} />
          </div>
        )}
      </ModalSheet>
      <Modal
        open={modalIsOpen}
        className={cn(styles.modal, styles.desktopModal)}
        portalClassName={styles.portalDesktop}
        withCloseIcon
        testId="bookingModal"
        onClose={onCloseClick}
      >
        <div className={styles.formWrapper}>
          {badge
            && <Typography
              variant="bodyS"
              className={styles.badge}
              component="span"
            >
              {badge}
            </Typography>
          }
          <Typography
            variant="h3"
            weight="semiBold"
            className={styles.title}
          >
            {title} <span className={styles.titleHeading}>{titleHeading}</span>
          </Typography>
          <Typography
            variant="bodyM"
            className={styles.description}
          >
            {description}
          </Typography>
          {list && <ul className={styles.list}>
            {list.map((item, index) => (
              <Typography
                key={index}
                className={styles.listItem}
                variant="bodyM"
                component="li"
              >
                <CheckIcon className={styles.listIcon} />
                {item}
              </Typography>
            ))}
          </ul>}
          <div className={styles.actions}>
            {
              buttonText.length > 0
              && <Button
                variant="back"
                className={styles.action}
                onClick={onCloseClick}
                component="a"
                href={buttonLink}
              >
                {buttonText}
              </Button>
            }
          </div>
        </div>
        {imageUrl && (
          <img src={imageUrl} alt={imageAltText} className={styles.image} />
        )}
      </Modal>
    </>
  )
};

export default ModalOffer;
